
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/over-ons/team",
      function () {
        return require("private-next-pages/over-ons/team/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/over-ons/team"])
      });
    }
  